import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Card,
  Typography,
  message,
  Switch,
  Tooltip,
} from "antd";
import { LinkOutlined } from "@ant-design/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import ShareLinksService from "services/ShareLinksService";

const { Text } = Typography;

const ModalSharing = ({
  isOpenModalSharing,
  setIsOpenModalSharing,
  linkSharingData,
  translation,
}) => {
  const [enabled, setEnabled] = useState(true);
  const handleCancel = () => {
    setIsOpenModalSharing(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(linkSharingData?.shareLink);
    message.success(translation("vehicleRecords.copiedLink"));
  };

  const handleDisabledLinkSharing = async (data, val) => {
    try {
      const res = await ShareLinksService.update({
        id: data?.shareLinkId,
        data: {
          isActive: val ? 1 : 0,
          shareToken: data?.shareToken,
          resourceType: "VEHICLE_PROFILE",
          resourceId: data?.resourceId?.toString(),
        },
      });
      console.log(res);
    } catch (err) {
      console.error("Update failed", err);
    }
  };

  useEffect(() => {
    setEnabled(linkSharingData?.isActive === 1);
  }, [linkSharingData]);

  return (
    <Modal
      title={
        <span className="fw-bold fs-5">
          {translation("vehicleRecords.vehicleProfileSharing")}
        </span>
      }
      open={isOpenModalSharing}
      onCancel={handleCancel}
      footer={null}
      width={520}
      centered
    >
      <Card size="small" className="shadow-sm border rounded-3 p-2">
        {/* Toggle chia sẻ */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Text strong className="">
            {translation("vehicleRecords.enableSharing")}
          </Text>
          <Switch
            checked={enabled}
            onChange={async (val) => {
              setEnabled(val);
              await handleDisabledLinkSharing(linkSharingData, val);
            }}
          />
        </div>

        {/* Copy link */}
        {enabled ? (
          <div className="d-flex justify-content-between align-items-center">
            <Text strong className="text-truncate" style={{ maxWidth: 300 }}>
              {translation("vehicleRecords.copyLink")}
            </Text>
            <Tooltip>
              <Button
                type="primary"
                icon={<LinkOutlined />}
                onClick={handleCopy}
                className="rounded-pill"
              >
                {translation("vehicleRecords.copyLink")}
              </Button>
            </Tooltip>
          </div>
        ) : (
          <div className="text-muted fst-italic text-center py-3">
            {translation("vehicleRecords.sharingDisabled")}
          </div>
        )}
      </Card>
    </Modal>
  );
};

export default ModalSharing;
